/**
 * Reads a CSS custom property value from the computed style of an element.
 * Pure function counterpart to useCssCustomProperty — safe to call outside React components.
 */
export const getCssCustomProperty = (
  customProperty: string,
  element: HTMLElement = document.documentElement,
): string => {
  const prop = customProperty.startsWith('--')
    ? customProperty
    : `--${customProperty}`;

  return getComputedStyle(element).getPropertyValue(prop).trim();
};
